<template>
    <div class="swiper-container" :class="swipeid">
      <div class="swiper-wrapper">
        <slot name="swiper-con"></slot>
      </div>
      <!-- 分页器 -->
      <div :class="{'swiper-pagination':pagination}"></div>
      <!--切换箭头-->
      <slot name="swiper-arrow" v-if="arrowButton"></slot>
    </div>
</template>
<script>
  import './swiper.js'

  export default {
    name: 'zm-swipe',
    props: {
      swipeid: {
        type: String,
        default: ''
      },
      effect: {
        type: String,
        default: 'slide'
      },
      loop: {
        type: Boolean,
        default: false
      },
      direction: {
        type: String,
        default: 'horizontal'
      },
      pagination: {
        type: Boolean,
        default: true
      },
      autoplay: {
        default: 5000
      },
      paginationType: {
        type: String,
        default: 'bullets'
      },
      slidesPerView: {
        type: String
      },
      arrowButton: {
        type: Boolean,
        default: false
      },
      onSlideNextStart: {
        type: Function,
        default: null
      },
      onSlideNextEnd: {
        type: Function,
        default: null
      },
      onProgress: {
        type: Function,
        default: null
      },
      onSetTransition: {
        type: Function,
        default: null
      },
      onSlideChangeStart: {
        type: Function,
        default: null
      },
      allowSwipeToNext: {
        type: Boolean,
        default: true
      },
      noSwiping: {
        type: Boolean,
        default: false
      },
      watchSlidesProgress: {
        type: Boolean,
        default: false
      },
      centeredSlides: {
        type: Boolean,
        default: false
      },
      loopedSlides: {
        type: Number
      }
    },
    data() {
      return {
        dom: ''
      }
    },
    mounted() {
      let That = this
      let option = {
        loop: That.loop,
        pagination: '.swiper-pagination',
        paginationType: That.paginationType, // fraction,progress,bullets
        autoplay: That.autoplay,
        direction: That.direction,
        effect: That.effect,
        autoplayDisableOnInteraction: false,
        allowSwipeToNext: That.allowSwipeToNext,
        noSwiping: That.noSwiping,
        observer: true,
        observeParents: true,
        onSlideNextStart: That.onSlideNextStart,
        onSlideNextEnd: That.onSlideNextEnd,
        onProgress: That.onProgress,
        onSetTransition: That.onSetTransition,
        onSlideChangeStart: That.onSlideChangeStart,
        watchSlidesProgress: That.watchSlidesProgress,
        slidesPerView: That.slidesPerView,
        centeredSlides: That.centeredSlides,
        loopedSlides: That.loopedSlides
      }
  
      if (That.arrowButton) {
        Object.assign(option, {
          prevButton: '.swiper-button-prev',
          nextButton: '.swiper-button-next'
        })
      }
      window.ZM_SWIPER = this.dom = new Swiper('.' + That.swipeid, option)
    }
  }
</script>
<style lang="scss">
  @import './swiper.min.css';
  @import "../../styles/mixin.scss";

  /*.swiper-container-horizontal>.swiper-pagination-bullets, .swiper-pagination-custom, .swiper-pagination-fraction {
    position: absolute;
    left: 50%;
    bottom: px2rem(80);
    transform: translateX(-50%);
    z-index: 100;
  }
  .swiper-pagination-bullet {
    width: px2rem(20);
    height: px2rem(20);
    border-radius: 50%;
    vertical-align: middle;
  }
  .swiper-pagination-bullet-active {
    width: px2rem(30);
    height: px2rem(30);
    border: px2rem(10) solid #fff;
    background: #ed444e;
    border-radius: 50%;
  }*/
</style>
